import React, { useCallback, useState } from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";

const Container = styled.div({
  position: "relative",
  width: "100%",
});

const IconBox = styled.div({
  position: "absolute",
  top: "50%",
  left: "1.2rem",
  transform: "translate(0,-50%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const SearchInputBox = styled.input(({ theme }) => ({
  width: "100%",
  padding: "1.2rem 0rem 1.2rem 4.4rem",
  fontSize: "1.6rem",
  lineHeight: "1.6rem",
  fontWeight: theme.fontWeight.medium,
  border: "none",
  textAlign: "start",

  backgroundColor: theme.color.border_gray,
  color: theme.color.black,

  "::placeholder": {
    color: theme.color.light_gray,
  },
}));

type Props = {
  inputValue: string;
  setInputValue: (value: string) => void;
  placeholder?: string;
  onClick?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};
const SearchInput = ({
  placeholder = "검색",
  inputValue,
  setInputValue,
  onClick,
}: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    setInputValue(value);
  };

  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const encodedQuery = encodeURIComponent(inputValue);

    if (e.key === "Enter") {
      navigate(`/search-results?query=${encodedQuery}`);
    }
  };

  return (
    <Container>
      <SearchInputBox
        type="text"
        onChange={handleChange}
        value={inputValue}
        placeholder={t(placeholder)}
        onKeyUp={onClick ? onClick : handleKeyUp}
      />

      <IconBox>
        <Image
          src={theme.image.search_icon.default}
          width="2rem"
          height="2rem"
        />
      </IconBox>
    </Container>
  );
};

export default SearchInput;
